<div class="wrap" [ngClass]="{ middle: isLoading }">
  <!-- <img [src]="imgDashboard" alt="image_depuis_dashoboard" /> -->
  <h1>Automatic Number Plate Recognition (ANPR)</h1>
  <div class="middle" *ngIf="isLoading">
    <mat-spinner color="primary" diameter="50"></mat-spinner>
    <p>Please wait...</p>
  </div>
  <div class="layout horizontal">
    <div class="layout vertical left">
      <!-- <p>{{ selectedCall.numberPlate }}</p> -->
      <div class="layout horizontal center">
        <app-current-license
          [license]="license"
          [dateBefore2weeks]="dateBefore2weeks"
          *ngIf="!isLoading"
        ></app-current-license>
        <div class="button-container">
          <input
            type="file"
            class="file-input"
            (change)="onFileSelected($event)"
            #fileUpload
          />
          <div class="file-upload">
            <button
              mat-raised-button
              color="primary"
              [disabled]="!canUseAnpr"
              (click)="fileUpload.click()"
              *ngIf="!isLoading"
            >
              <fa-icon [icon]="faCamera"></fa-icon><span> Send a picture </span>
            </button>
          </div>
        </div>
      </div>
      <app-history
        [calls]="this.calls"
        [answer]="answer"
        *ngIf="!isLoading && license"
        (selectedCallEvent)="updateSelectedCall($event)"
      ></app-history>
    </div>
    <div class="workzone-container">
      <app-anpr-zone
        [call]="selectedCall"
        [img]="img"
        [isLoading]="isLoading"
        *ngIf="license && selectedCall"
        (answerEvent)="afterAnswer($event)"
      ></app-anpr-zone>
    </div>
  </div>
</div>
